import React, { useEffect } from "react";
import { DragDropStyledContainer } from "../../../common/dropFiles/dragdropfiles";

import "./Verification.scss";

import { AttachmentsUpload, Button } from "abs-ui-components";

const VerificationSelectFiles = ({ handleUploadClick, toggleClose, setSelectedFiles, selectedFiles, showModal }) => {
	useEffect(() => {
		if (!showModal) {
			setSelectedFiles([]);
		}
	}, [showModal, setSelectedFiles]);

	const handleLocalFilesSelected = (files) => {
		const newFiles = [...selectedFiles];
		files.forEach((selectedFile) => {
			newFiles.push(selectedFile.file);
		});
		setSelectedFiles(newFiles);
	};

	const handleLocalUploadClick = () => {
		handleUploadClick();
		toggleClose();
	};

	const handleRemoveFile = (index) => {
		const newFiles = selectedFiles.filter((_, i) => i !== index);
		setSelectedFiles(newFiles);
	};

	return (
		<div className="p-4">
			<div className="mb-3">
				<DragDropStyledContainer>
					<AttachmentsUpload
						onFilesSelected={handleLocalFilesSelected}
						supportedFormat=" "
						supportedFileTypes="zip, csv, png, jpg, jpeg, eml, tiff, bmp, txt, ppt, pptx, xls, xlsx, rtf, dwg, gif, pdf"
					/>
				</DragDropStyledContainer>
			</div>

			{selectedFiles.length > 0 && (
				<div className="mb-3">
					<div className="selected-files">
						{selectedFiles.map((file, index) => (
							<div key={`verification-${index}`} className="file-item">
								<span>{file.name}</span>
								<button className="remove-btn" onClick={() => handleRemoveFile(index)}>
									✖
								</button>
							</div>
						))}
					</div>
				</div>
			)}
			<div className="center-content">
				<Button disabled={selectedFiles?.length === 0} onClick={handleLocalUploadClick}>
					Upload for publishing
				</Button>
			</div>
		</div>
	);
};

export default VerificationSelectFiles;
